import api from "!../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../css-loader/dist/cjs.js??clonedRuleSet-38[0].rules[0].use[1]!../laravel-mix/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-38[0].rules[0].use[2]!./swiper-bundle.min.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};